import { render, staticRenderFns } from "./GroupHeaderRenderer.vue?vue&type=template&id=19d1807c&scoped=true"
import script from "./GroupHeaderRenderer.vue?vue&type=script&lang=js"
export * from "./GroupHeaderRenderer.vue?vue&type=script&lang=js"
import style0 from "./GroupHeaderRenderer.vue?vue&type=style&index=0&id=19d1807c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1807c",
  null
  
)

export default component.exports